module.exports = __webpack_public_path__ + "img/1480595940.d7800af0.jpg";